/* eslint-disable prettier/prettier */
<template>
  <LayoutWithNav>
    <PopupAlert v-model="showFood" type="food" />
    <PopupAlert v-model="showProtect" @click:keep="clickTo('/location')" type="protect" />
    <img
      src="@/assets/images/newbg_t.jpg"
      style="
        position: absolute;
        top: 0px;
        left: 0;
        width: 100%;
        height: 100%;
        aspect-ratio: 375/812;
        pointer-events: none;
      "
      alt=""
    />
    <NavBarMain
      :is-prev="false"
      color="linear-gradient(180deg, #FFAB5B 0%, rgba(255, 171, 91, 0) 100%)"
    >
      <template #left_icon><div></div></template>
      <template #title>
        <img
          style="width: 108px; transform: translateY(-2px)"
          src="@/assets/images/index_logo.svg"
          alt=""
        />
      </template>
      <template #map>
        <img
          style="width: 24px"
          class="bell"
          src="@/assets/images/map.svg"
          alt=""
          @click="clickTo('/storeCheck')"
        />
      </template>
      <template #right_icon>
        <img
          style="width: 24px"
          class="bell"
          src="@/assets/images/bell.svg"
          alt=""
          @click="clickTo('/info')"
        />
      </template>
    </NavBarMain>
    <PopupCarrier v-if="isCarrier" @update:modelValue="getValue" :data="memberNo" />
    <div v-if="!$store.state.isLoading" class="home" style="font-family: 'Noto Sans TC'">
      <div v-if="imgsCount" class="banner" style="overflow: hidden;margin-bottom: 16px;">
        <BannerSwiper :data="bannerList" />
      </div>
      <div v-if="login" class="id_card" @click="clickTo('/mypoint')">
        <div
          class="card"
          :style="{
            backgroundImage: `url(${
              isVip
                ? require('@/assets/images/card_vip.jpg')
                : require('@/assets/images/card_orange.jpg')
            })`,
          }"
        >
          <div v-show="isVip" class="maskLoad">
            <div class="load"></div>
          </div>
          <div class="info">
            <div
              class="name"
              :style="{ opacity: login ? 1 : 0, 'pointer-events': login ? 'auto' : 'none' }"
            >
              <img :src="image" />
              <p>{{ name }}</p>
            </div>
            <div class="pet_carrier" @click.stop="openCarrier">
              <img src="@/assets/images/barcode.svg" alt="" />
            </div>
          </div>
          <div class="point">
            <p>
              {{ login ? card_point ? card_point.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0 : 0
              }}<span>點</span>
            </p>
          </div>
          <div class="over_point">
            2025/03/31<span>到期點數</span>：{{
              login ? over_point ? over_point.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0 : 0
            }}
          </div>
        </div>
      </div>
      <div class="func_area">
        <div class="func_item" v-for="(el, idx) in funcList" :key="idx" @click="clickTo(el.url)">
          <img :src="el.src" alt="" />
          <p>{{ el.name }}</p>
        </div>
      </div>
      <img
        v-if="tagList.length > 0"
        style="
          position: absolute;
          width: 100%;
          left: 0;
          transform: translateY(135%);
          pointer-events: none;
        "
        src="@/assets/images/intersect.png"
        alt=""
      />
      <div class="title" v-if="!$store.state.isLoading && tagList.length > 0">
        <img src="@/assets/images/title_reserve.png" alt="" />
        <p>本月職人推薦</p>
      </div>
      <div v-if="tagList.length > 0" class="tag">
        <TagSwiper @click-index="getSelectIndex" :data="tagList" />
      </div>
      <div v-if="tagList.length > 0" class="man">
        <ManSwiper :tag="currentTag" :data="recommendList" />
      </div>
    </div>
    <img
      src="@/assets/images/newbg_b.png"
      style="
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        aspect-ratio: 375/436;
        pointer-events: none;
      "
      alt=""
    />
    <LB :open="lbGiftOpen" @closeLb="closeGiftLb" class="lb">
      <h4><font>註冊好禮輕鬆領</font></h4>
      <div class="d_flex">
        <div class="step st1">
          <img src="../assets/images/imgImgHomeLB01.svg" alt="" />
          <p class="f_green">步驟1</p>
          <p class="f_grey">填寫會員資料</p>
          <button @click="loginActivity(1)" :class="{ not_yet: !signUp1, done: signUp1 }">
            {{ signUp1 ? '' : '前往填寫' }}
          </button>
        </div>
        <div class="step st2">
          <img src="../assets/images/imgImgHomeLB02.svg" alt="" />
          <p class="f_green">步驟2</p>
          <p class="f_grey">填寫寵物資料</p>
          <button @click="loginActivity(2)" :class="{ not_yet: !signUp2, done: signUp2 }">
            {{ signUp2 ? '' : '前往填寫' }}
          </button>
        </div>
      </div>
      <!-- <v-btn
                :class="{ inactive: signUp1 && signUp2 }"
                class="get_gift"
                @click="getCoupon()"
            >
                領好禮
            </v-btn> -->
      <div class="row" style="justify-content: center; margin-top: 13px; height: 20px">
        <FancyCheck v-model="isSevenDays" type="checkbox" style="margin-right: -6px" />
        <span style="font-size: 13px; margin-top: 3px">七日內不再提醒</span>
      </div>
    </LB>
    <LB :open="lbProdOpen" @closeLb="closeLb" class="lb">
      <h4><font>本月職人推薦</font></h4>
      <div class="product">
        <div class="detail_wrapper d_flex">
          <h5>{{ lbProdData.title }}</h5>
          <div class="W100 mb-4 mt-4">
            <h6>{{ lbProdData.type }}</h6>
            <span class="price">{{ lbProdData.price }}</span>
          </div>
        </div>
        <div class="img_wrapper">
          <img :src="lbProdData.imgSrc" alt="" />
        </div>
      </div>
    </LB>
  </LayoutWithNav>
</template>

<script>
import BannerSwiper from '@/components/BannerSwiper.vue'
import ManSwiper from '@/components/manSwiper.vue'
import TagSwiper from '@/components/tagSwiper.vue'
import LayoutWithNav from '@/layouts/LayoutWithNav.vue'
import PopupCarrier from '@/components/Popup/PopupCarrier.vue'
import NavBarMain from '@/components/NavBarMain.vue'
import PopupAlert from '@/components/Popup/PopupAlert.vue'
import LB from '@/components/LB.vue'

import {
  KgQueryMemberBonus,
  getBannerList,
  checkPersonalData,
  checkPetData,
  getRegPre,
  checkReg,
  getHomePageArticle,
  getRecommendList,
  getRecommendImage,
  getCouponList,
  getPersonalCouponList,
  updateDeviceToken,
  GetCarrier,
  GetActivityCategory,
  GetRecommend,
  getUserInfo,
  getMemberImage,
  checkIsVIP
} from '@/apis/api.js'
export default {
  name: 'Home',
  components: {
    LayoutWithNav,
    NavBarMain,
    BannerSwiper,
    ManSwiper,
    PopupCarrier,
    TagSwiper,
    PopupAlert,
    LB,
  },
  data: () => ({
    login: false,
    name: '',
    image: '',
    isVip: false,
    showFood: false,
    showProtect: false,
    memberNo: '',
    card_level: 0,
    card_word: '一般',
    card_point: 0,
    over_point: 0,
    isCarrier: false,
    isSevenDays: false,
    refreshKey: 0,
    funcList: [
      {
        name: '我的點數',
        src: require('@/assets/images/widget_icon.png'),
        url: '/mypoint',
      },
      {
        name: '優惠票券',
        src: require('@/assets/images/widget_card.png'),
        url: '/info/coupon',
      },
      {
        name: '美容預約',
        src: require('@/assets/images/widget_beauty.png'),
        url: 'check',
      },
      {
        name: '線上DM',
        src: require('@/assets/images/widget_dm.png'),
        url: '/dm',
      },
      {
        name: '門市據點',
        src: require('@/assets/images/widget_place.png'),
        url: '/location',
      },
      {
        name: '門市活動',
        src: require('@/assets/images/widget_active.png'),
        url: '/info?type=msg',
      },
      {
        name: '寵物鮮食',
        src: require('@/assets/images/widget_food.png'),
        url: '',
      },
      {
        name: '營養計算',
        src: require('@/assets/images/widget_cal.png'),
        url: '/tools/calculator',
      },
    ],
    currentTag: '',
    tagList: [],
    recommendList: [],
    prodList: [],
    // ifGiftShow: false,
    lbProdOpen: false,
    lbProdData: {},
    signUp1: true,
    signUp2: true,
    canGetCoupon: false,
    bannerList: [],
    transitionName: 'right-in',
    imgsCount: 0,
    couponUngetList: [],
    couponUndoneList: [],
  }),
  computed: {
    // barcodeColor() {
    //   switch (this.card_level) {
    //     case 0:
    //       return '#FF9F4B'
    //     case 1:
    //       return '#996C50'
    //     case 2:
    //       return '#979797'
    //     case 3:
    //       return '#B79A44'
    //     case 4:
    //       return '#707070'
    //     default:
    //       return '#FF9F4B'
    //   }
    // },
    // typeColor() {
    //   switch (this.card_level) {
    //     case 0:
    //       return 'level_0'
    //     case 1:
    //       return 'level_1'
    //     case 2:
    //       return 'level_2'
    //     case 3:
    //       return 'level_3'
    //     case 4:
    //       return 'level_4'
    //     default:
    //       return 'level_0'
    //   }
    // },
    couponNotificationCount() {
      return this.couponUndoneList.length
    },
    lbGiftOpen() {
      this.refreshKey
      let openTime = parseInt(localStorage.getItem('giftOpenTime'))
      if (!openTime) openTime = 0
      let nowTime = new Date().getTime()
      if (this.signUp1 && this.signUp2) {
        return false
      } else {
        if (nowTime >= openTime) return true
        else return false
      }
      // return true
    },
  },
  beforeCreate() {
    this.$store.state.isLoading = true
  },
  created() {
    var parent = this
    // 先綁fcm_token/device_id
    if (parent.$route.query.fcm_token)
      localStorage.setItem('fcm_token', parent.$route.query.fcm_token)
    // 有登入狀態可以綁手機
    if (localStorage.getItem('phone')) {
      this.login = true
      getUserInfo(localStorage.getItem('phone'), localStorage.getItem('password'))
        .then(function (rsp) {
          return JSON.parse(rsp)
        })
        .then(function (rsp) {
          parent.name = rsp.c_name
        })
      getMemberImage(localStorage.getItem('phone'), localStorage.getItem('password')).then(
        function (rsp) {
          if (rsp) parent.image = rsp
          else parent.image = require(`@/assets/images/imgMemberM.svg`)
          // setTimeout(function () {
          //   parent.$store.state.isLoading = false
          // }, 500)
        }
      )
      updateDeviceToken(localStorage.getItem('phone'), localStorage.getItem('fcm_token')).then(
        function (rsp) {
          console.log('updateDeviceToken', rsp)
        }
      )
    } else {
      this.login = false
    }
    // Banner list
    getBannerList().then(result => {
      if (result) {
        parent.bannerList = result.result.map(function (obj) {
          return obj.pic_url.replace('http:', 'https:')
        })
        if (parent.bannerList.length > 8) parent.bannerList = parent.bannerList.slice(0, 8)
        parent.imgsCount = parent.bannerList.length
      }
      setTimeout(function () {
        parent.$store.state.isLoading = false
      }, 1000)
    })
    // 寵知識三種
    getHomePageArticle().then(function (rsp) {
      var data = JSON.parse(rsp)
      console.log('getHomePageArticle', data)
      // for (let i in data) {
        // if (data[i].article == 'petfood') {
        //     parent.funcList[2].href.query.category_id = 'knowledge';
        //     parent.funcList[2].href.query.article_id =
        //         data[i].content_id;
        // }
        // else if (data[i].article == 'petknow') {
        //     parent.funcList[6].href.query.category_id = 'knowledge';
        //     parent.funcList[6].href.query.article_id =
        //         data[i].content_id;
        // }
        // if (data[i].article == 'doctorchat') {
        //   parent.funcList[7].href.query.category_id = 'veterinary'
        //   parent.funcList[7].href.query.article_id = data[i].content_id
        // }
      // }
    })
    // 職人推薦
    getRecommendList().then(function (rsp) {
      parent.prodList = []
      for (let i in rsp) {
        getRecommendImage(rsp[i].id).then(function (image) {
          setTimeout(function () {
            parent.prodList.push({
              sort: rsp[i].sort,
              title: rsp[i].p_name,
              price: rsp[i].price,
              type: rsp[i].tag,
              imgSrc: image,
            })
            if (parent.$route.query.item_id && parent.$route.query.item_id == rsp[i].id) {
              parent.openProdLB({
                sort: rsp[i].sort,
                title: rsp[i].p_name,
                price: rsp[i].price,
                type: rsp[i].tag,
                imgSrc: image,
              })
            }
            if (i == rsp.length - 1) {
              parent.prodList.sort((a, b) => (a.sort < b.sort ? -1 : b.sort > a.sort ? 1 : 0))
            }
          }, 100 * i)
        })
      }
    })
    GetActivityCategory().then(function (rsp) {
      parent.tagList = rsp.data
      parent.currentTag = parent.tagList[0]?.activity_category_name
    })
    GetRecommend().then(async function (rsp) {
      let results = rsp
      parent.recommendList = []
      let promises = results.map(async item => {
        let image = await getRecommendImage(item.id)
        return {
          sort: item.sort,
          title: item.p_name,
          price: item.price,
          promotion: item.promotion,
          type: item.tag,
          category: item.activityCategory,
          imgSrc: image,
          DM: item.DM,
          id: item.id,
          links: item.links,
          shop_link_url: item.shop_link_url,
        }
      })
      parent.recommendList = await Promise.all(promises)  
      parent.$store.state.isLoading = false
    })
    if (
      !localStorage.getItem('phone') ||
      !localStorage.getItem('password') ||
      !localStorage.getItem('member_no')
    ) {
      // this.$router.push('/login');
      // parent.signUp1 = true;
      // parent.signUp2 = true;
      // parent.canGetCoupon = false;
    } else {
      this.memberNo = localStorage.getItem('member_no')
      checkIsVIP(localStorage.getItem('phone'), localStorage.getItem('password'))
        .then(function(rsp){
          parent.isVip = rsp.data.isVIP
        })
      GetCarrier(localStorage.getItem('phone'), localStorage.getItem('password'))
        .then(rsp => JSON.parse(rsp))
        .then(rsp => {
          parent.carrier = rsp.carrier ? rsp.carrier : ''
        })
      checkReg(localStorage.getItem('phone'), localStorage.getItem('password')).then(function (
        rsp
      ) {
        if (!rsp) {
          parent.signUp1 = true
          parent.signUp2 = true
          parent.canGetCoupon = false
        } else {
          checkPersonalData(localStorage.getItem('phone'), localStorage.getItem('password')).then(
            function (rsp) {
              if (rsp) {
                parent.canGetCoupon = true
                parent.signUp1 = true
              } else {
                parent.canGetCoupon = true
                parent.signUp1 = false
              }
            }
          )
          checkPetData(localStorage.getItem('phone'), localStorage.getItem('password')).then(
            function (rsp) {
              if (rsp) {
                parent.canGetCoupon = true
                parent.signUp2 = true
              } else {
                parent.canGetCoupon = true
                parent.signUp2 = false
              }
            }
          )
        }
      })

      KgQueryMemberBonus(localStorage.getItem('phone'), localStorage.getItem('member_no')).then(
        function (rsp) {
          parent.card_point = rsp.MEB_Bonus          
          parent.over_point = rsp.MEB_BonusLastYear
        }
      )

      var newDateObj = new Date()
      var today =
        newDateObj.getFullYear().toString() +
        (newDateObj.getMonth() + 1 < 10
          ? '0' + (newDateObj.getMonth() + 1).toString()
          : newDateObj.getMonth() + 1
        ).toString() +
        (newDateObj.getDate() < 10
          ? ('0' + newDateObj.getDate()).toString()
          : newDateObj.getDate()
        ).toString()

      getCouponList(localStorage.getItem('phone'), localStorage.getItem('password')).then(function (
        all_coupon_list
      ) {
        if (all_coupon_list.length && all_coupon_list) {
          parent.couponUngetList = []
          parent.couponUndoneList = []
          parent.couponDoneList = []
          getPersonalCouponList(
            localStorage.getItem('phone'),
            localStorage.getItem('password')
          ).then(function (personal_coupon_list) {
            console.log(all_coupon_list, personal_coupon_list)
            for (let i in all_coupon_list) {
              for (let j in personal_coupon_list) {
                if (all_coupon_list[i].tNo == personal_coupon_list[j].tNo) {
                  all_coupon_list[i].endDate = personal_coupon_list[j].endDate
                }
              }
            }
            let per_check_index = []
            for (let i in all_coupon_list) {
              var endDateTime = new Date(
                all_coupon_list[i].endDate.slice(0, 4) +
                  '/' +
                  all_coupon_list[i].endDate.slice(4, 6) +
                  '/' +
                  all_coupon_list[i].endDate.slice(6, 8)
              ).getTime()
              var nowDateTime = new Date().getTime()
              var expired_days = (nowDateTime - endDateTime) / (1000 * 60 * 60 * 24)
              if (all_coupon_list[i].startDate <= today && all_coupon_list[i].endDate >= today) {
                var have = false
                all_coupon_list[i].type = '優惠票卷'
                for (let j in personal_coupon_list) {
                  if (
                    per_check_index.indexOf(j) == -1 &&
                    all_coupon_list[i].tNo == personal_coupon_list[j].tNo
                  ) {
                    have = true
                    per_check_index.push(j)
                    console.log('per_check_index', per_check_index)
                    if (personal_coupon_list[j].isUse == '1') {
                      all_coupon_list[i].endDate = personal_coupon_list[j].endDate
                      parent.couponDoneList.push(all_coupon_list[i])
                    } else {
                      console.log('match', j)
                      all_coupon_list[i].endDate = personal_coupon_list[j].endDate
                      all_coupon_list[i].pcid = personal_coupon_list[j].pcid
                      let temp_coupon = JSON.parse(JSON.stringify(all_coupon_list[i]))
                      temp_coupon.index = j
                      parent.couponUndoneList.push(temp_coupon)
                    }
                  }
                  if (j == personal_coupon_list.length - 1) {
                    if (!have && all_coupon_list[i].isvisible != 'False')
                      if (expired_days >= 1) {
                        parent.couponUngetList.push(all_coupon_list[i])
                      } else {
                        parent.couponUndoneList.push(all_coupon_list[i])
                      }
                  }
                }
                if (
                  (!personal_coupon_list.length || !personal_coupon_list) &&
                  all_coupon_list[i].isvisible != 'False'
                )
                  parent.couponUngetList.push(all_coupon_list[i])
              } else if (all_coupon_list[i].endDate < today) {
                have = false
                all_coupon_list[i].type = '優惠票卷'
                for (let j in personal_coupon_list) {
                  if (all_coupon_list[i].tNo == personal_coupon_list[j].tNo) {
                    if (personal_coupon_list[j].isUse == '1') {
                      // 領取並用過且過期
                      have = true
                      all_coupon_list[i].valid = ''
                      all_coupon_list[i].endDate = personal_coupon_list[j].endDate
                      parent.couponUngetList.push(all_coupon_list[i])
                    } else {
                      // 領取沒用過且過期
                      have = true
                      all_coupon_list[i].valid = 'expired'
                      all_coupon_list[i].endDate = personal_coupon_list[j].endDate
                      if (expired_days < 30) parent.couponUngetList.push(all_coupon_list[i])
                    }
                  }
                  if (j == personal_coupon_list.length - 1) {
                    if (!have && all_coupon_list[i].isvisible != 'False') {
                      // 未領取且過期
                      all_coupon_list[i].valid = 'expired'
                      if (expired_days < 30) parent.couponUngetList.push(all_coupon_list[i])
                    }
                  }
                }
                if (
                  (!personal_coupon_list.length || !personal_coupon_list) &&
                  all_coupon_list[i].isvisible != 'False'
                ) {
                  all_coupon_list[i].valid = 'expired'
                  if (expired_days < 30) parent.couponDoneList.push(all_coupon_list[i])
                }
              }
              if (i == all_coupon_list.length - 1) {
                parent.couponUngetList.sort(function (a, b) {
                  return (
                    b.create_time.replace('T', '').replace(/:/g, '') -
                    a.create_time.replace('T', '').replace(/:/g, '')
                  )
                })
                parent.couponUndoneList = JSON.parse(JSON.stringify(parent.couponUndoneList)).sort(
                  function (a, b) {
                    return parseInt(b.index) - parseInt(a.index)
                  }
                )
                console.log('parent.couponUndoneList', parent.couponUndoneList)
                parent.couponDoneList.sort(function (a, b) {
                  return (
                    b.create_time.replace('T', '').replace(/:/g, '') -
                    a.create_time.replace('T', '').replace(/:/g, '')
                  )
                })
              }
            }
          })
        }
      })
    }
  },
  mounted() {
    console.log(
      localStorage.getItem('member_no'),
      localStorage.getItem('password'),
      localStorage.getItem('phone')
    )
    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$store.state.isLoading = false;
    //     }, 1000);
    // });
  },
  methods: {
    openCarrier() {
      if (this.login) {
        this.isCarrier = true
      } else {
        this.$router.push('/login')
      }
    },
    isTodayInRange(startdate, enddate) {
      const today = new Date() // 取得今天的日期
      today.setHours(0, 0, 0, 0) // 移除時間部分，確保只比較日期

      const start = new Date(startdate)
      const end = new Date(enddate)

      return today >= start && today <= end
    },
    getSelectIndex(tag) {
      this.currentTag = tag
    },
    getValue(v) {
      this.isCarrier = v
    },
    getWord() {
      switch (this.card_level) {
        case 0:
          return '一般'
        case 1:
          return '銅級'
        case 2:
          return '銀級'
        case 3:
          return '黃金'
        case 4:
          return '白金'
        default:
          break
      }
    },
    clickTo(url) {
      if (url == '') {
        this.showFood = true
      } else if (url === 'check'){
        if(this.$store.state.isBeautyEnabled){
          this.$router.push('/salon/order/edit?where=index')
        }else{
          this.showProtect = true
        }
      } else {
        this.$router.push(url)
      }
    },
    loginActivity(type) {
      if (type == 1 && !this.signUp1) this.$router.push('/member/info')
      else if (type == 2 && !this.signUp2) this.$router.push('/register/pet?type=home')
      // this[`signUp${type}`] = true;
    },
    closeLb() {
      this.lbProdOpen = false
    },
    closeGiftLb() {
      if (this.isSevenDays) {
        let openTime = new Date().getTime() + 1000 * 60 * 60 * 24 * 7
        localStorage.setItem('giftOpenTime', openTime)
        this.refreshKey += 1
      } else {
        let openTime = new Date().getTime() + 1000 * 60 * 10
        localStorage.setItem('giftOpenTime', openTime)
        this.refreshKey += 1
      }
    },
    openProdLB(data) {
      this.lbProdOpen = true
      this.lbProdData = data
    },
    redirect(link) {
      setTimeout(() => {
        this.$router.push(link)
      }, 500)
    },
    getCoupon() {
      var parent = this
      if (this.signUp1 && this.signUp2) {
        getRegPre(localStorage.getItem('phone'), localStorage.getItem('password')).then(function (
          rsp
        ) {
          if (rsp) {
            parent.redirect('/info/coupon?type=use')
          }
        })
      }
    },
  },
  watch: {
    couponNotificationCount(newCount) {
      const couponItem = this.funcList.find(item => item.name === '優惠票券')
      if (couponItem) {
        couponItem.notify = newCount
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.indexNav {
  background-color: #ffa24f;
  position: fixed;
  z-index: 10;
  top: 0;
  width: 100%;
  padding: 16.37px 0px 19.4px;
  display: flex;
  align-items: center;
  justify-content: center;
  & .bell {
    position: absolute;
    right: 20px;
  }
}
.id_card {
  padding: 0px 57.5px 16px;
  & .card {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-size: cover;
    padding: 12px 19px 8px 14px;
    overflow: hidden;
    position: relative;
    width: 100%;
    aspect-ratio: 260/130;
    box-shadow: 0px 2px 4px 0px #0000001F, -0.7px -0.7px 1px 0px #0000001F inset, 0.7px 0.7px 1px 0px #FFFFFFCC inset;
    border-radius: 12px;
    & .pet {
      width: 171px;
      position: absolute;
      bottom: 0;
      right: 0;
      pointer-events: none;
    }
    & .dot1 {
      position: absolute;
      background-color: #fff;
      width: 4px;
      height: 4px;
      border-radius: 100%;
      bottom: 64%;
      right: 5%;
    }
    & .dot2 {
      position: absolute;
      background-color: #fff;
      width: 6px;
      height: 6px;
      border-radius: 100%;
      bottom: 69%;
      right: 4.5%;
    }
    & .pet_carrier {
      border-radius: 100%;
      width: 50%;
      right: 0;
      top: 0;
      width: 28px;
      height: 28px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      & img {
        width: 24px;
        height: 24px;
      }
    }
    & .info {
      display: flex;
      justify-content: space-between;
      width: 100%;
      background: transparent !important;
      & .name {
        display: flex;
        align-items: center;
        gap: 4px;
        & img {
          width: 24px;
          height: 24px;
          object-fit: cover;
          border-radius: 100%;
        }
        & p {
          font-size: 14px;
          line-height: 14.4px;
          letter-spacing: 4%;
          color: #fff;
          font-family: 'Noto Serif TC';
        }
        & .type {
          position: relative;
          display: flex;
          align-items: center;
          padding: 5px 10px;
          border-radius: 75px;
          gap: 2px;
          z-index: 1;
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: -1;
            transform: translate(-51%, -50%);
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            border-radius: 75px;
            border: solid 0.25px #fff;
          }
          & p {
            font-size: 8px;
            line-height: 8.8px;
            letter-spacing: 4%;
            color: #fff;
            align-content: center;
            transform: translateY(1px);
          }
          & img {
            width: 12px;
            height: 12px;
          }
        }
      }
    }
    & .point {
      display: flex;
      justify-content: center;
      align-items: center;
      transform: translateY(-70%);
      & p {
        font-weight: 700;
        color: #fff;
        font-size: 24px;
        line-height: 20px;
        font-family: 'Poltawski Nowy';
        & span {
          font-family: 'Noto Serif TC';
          font-size: 12px;
          line-height: 9px;
          font-weight: 500;
        }
      }
    }
    & .over_point {
      opacity: 0;
      pointer-events: none;
      text-align: right;
      font-size: 12px;
      line-height: 10.8px;
      letter-spacing: 0.36px;
      color: #fff;
      white-space: nowrap;
      font-family: 'Poltawski Nowy';
      & span {
        font-family: 'Noto Serif TC';
      }
    }
  }
}
.func_area {
  padding: 8px 32px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 20px;
  & .func_item {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 25%;
    & img {
      filter: drop-shadow(0px 2px 5px #4b251838);
      width: 48px;
      height: 48px;
      margin-bottom: 6px;
    }
    & p {
      margin-top: 0px;
      color: #363230;
      font-weight: 400;
      font-size: 14px;
      line-height: 16.8px;
      letter-spacing: 4%;
      text-align: center;
    }
  }
}
.home {
  // margin-top: 58px;
  font-family: Noto Sans TC;
  min-height: calc(100vh-60px);
  background-color: #fff;
  .tag {
    overflow-x: hidden;
  }
  .man {
    width: 100%;
    padding: 0px 24px;
    overflow-x: hidden;
  }
  .banner {
    overflow: hidden;
    width: 100%;
  }
  .booking {
    width: 100%;
    justify-content: space-between;
    padding: 10px 16px;
    div {
      width: calc(50% - 8px);
      border-radius: 10px;
      background-color: #fff;
      padding: 15px 0;
      justify-content: center;
      align-items: center;
      position: relative;
      overflow: hidden;
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        height: 100%;
        width: 100%;
        background-color: #ff9f48;
        border-radius: 50%;
        opacity: 0;
        pointer-events: none;
        transition: all ease-in-out 0.6s;
        transform: scale(2, 5) translate(-50%, -50%);
        transform-origin: left top;
      }
      &:active {
        &::after {
          padding: 0;
          margin: 0;
          opacity: 0.1;
          transition: 0s;
          transform: scale(0, 0) translate(-50%, -50%);
        }
      }
      img {
        margin-right: 8px;
      }
      span {
        font-size: 14px;
      }
    }
  }
  .func {
    background-color: #fff;
    justify-content: start;
    padding: 16px 16px 4px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
    > div {
      position: relative;
      width: 25%;
      margin-bottom: 12px;
      .funcImg {
        width: calc(100% - 20px);
        display: inline-block;
        margin: 0 auto 8px;
        border-radius: 50%;
        overflow: hidden;
        position: relative;

        img {
          width: 100%;
          vertical-align: top;
          position: relative;
          z-index: 1;
        }

        &::after {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          height: 100%;
          width: 100%;
          background-color: #ff9f48;
          border-radius: 50%;
          opacity: 0;
          pointer-events: none;
          transition: all 0.5s;
          transform: scale(1) translate(-50%, -50%);
          transform-origin: left top;
        }
        &:active {
          &::after {
            padding: 0;
            margin: 0;
            opacity: 0.2;
            transition: 0s;
            transform: scale(0, 0) translate(-50%, -50%);
          }
        }
      }

      p {
        margin-bottom: 0;
        line-height: 1.6;
        font-size: 14px;
        color: $color_main_black;
      }
      .notify {
        right: 12%;
        top: 0;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        width: 17px;
        height: 17px;
        border-radius: 50%;
        color: #fff;
        background-color: $color_main_first;
      }
    }
  }
  .product_list {
    width: calc(100% - 24px);
    margin: 8px auto 0;
    padding-bottom: 60px;
    background-color: #f1e4cf;
    border-radius: 24px;
    padding: 0 12px 12px;
    border: 2px solid #fff;

    h3 {
      background-image: url(~@/assets/images/imgImgHome11.svg);
      background-repeat: no-repeat;
      background-position: center top;
      background-size: 100%;
      width: 250px;
      line-height: 45px;
      color: #fff;
      font-size: 20px;
      margin: 0 auto 18px;
      font-weight: bold;
      &:before,
      &:after {
        content: '';
        background-image: url(~@/assets/images/icStar.svg);
        background-repeat: no-repeat;
        background-position: center;
        display: inline-block;
        width: 16px;
        height: 16px;
        margin: 0 8px;
      }
    }
    > .d_flex {
      width: 100%;
      justify-content: space-between;
      .item {
        width: calc(50% - 4px);
      }
    }
  }
  .gift {
    position: fixed;
    right: 8px;
    top: 70%;
    transform: translate(0, -50%);
    z-index: 10;
    .btn_close {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 20px);
      width: 24px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
}
.lb {
  .d_flex {
    margin-top: 36px;
    width: 100%;
    justify-content: space-evenly;
    img {
      margin-bottom: 10px;
    }
    p,
    button {
      margin-top: 8px;
    }
    .f_green {
      font-weight: bold;
      font-size: 16px;
      line-height: 19px;
    }
    .f_grey {
      font-size: 14px;
      line-height: 16px;
    }
    button {
      border: 2px solid #ffffff;
      display: inline-block;

      &.done {
        height: 20px;
        width: 20px;
        background-image: url(~@/assets/images/icCheck.svg);
        background-size: contain;
        text-indent: -10000px;
        overflow: hidden;
        border-radius: 10px;
      }
      &.not_yet {
        color: #fff;
        background-color: $color_main_first;
        font-size: 14px;
        line-height: 20px;
        border-radius: 15px;
        padding: 0 10px;
      }
    }
    .W100 {
      h6 {
        color: #fff;
        background-image: url(~@/assets/images/icTag.svg);
        background-repeat: no-repeat;
        background-position: left center;
        background-size: 40px;
        font-size: 12px;
        padding-left: 4px;
        display: inline-block;
        width: 50px;
        text-align: left;
      }
    }
  }
  .get_gift {
    line-height: 40px;
    border-radius: 20px;
    color: #fff;
    background: #cccccc !important;
    border: 2px solid #ffffff;
    border-radius: 22px;
    font-size: 20px;
    width: 148px;
    margin-top: 22px;
    &.inactive {
      background-color: $color_main_first !important;
    }
  }
  .product {
    padding-top: 10px;
  }
  .detail_wrapper {
    flex-direction: column;
    * {
      font-size: 14px;
    }

    .price {
      color: $color_main_second;
      margin: 5px auto 20px;
      &:before {
        content: '$';
      }
    }
  }
  .img_wrapper {
    img {
      max-height: 35vh;
    }
  }
}
.title {
  position: relative;
  width: 148px;
  margin: 20px auto 24px;
  & p {
    position: absolute;
    white-space: nowrap;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -70%);
    font-size: 16px;
    font-weight: bold;
    line-height: 19.2px;
    letter-spacing: 4%;
  }
}

.type.level_0 {
  background-color: #ffbd7e;
  &::after {
    background: linear-gradient(
      225.89deg,
      #ffbd7e -2.61%,
      #ffdaad 12.38%,
      #ff9f4b 37.35%,
      #ff9f4b 57.32%,
      #ffdaad 84.34%
    );
  }
}
.type.level_1 {
  background-color: #9b6e54;
  &::after {
    background: linear-gradient(
      225.89deg,
      #bda597 -2.61%,
      #d5ccc7 12.38%,
      #996b4f 37.35%,
      #9b6e54 57.32%,
      #ac8f7e 84.34%
    );
  }
}
.type.level_2 {
  background-color: #b7b7b7;
  &::after {
    background: linear-gradient(
      225.89deg,
      #bdbdbd -2.61%,
      #e6e6e6 12.38%,
      #b7b7b7 37.35%,
      #b7b7b7 57.32%,
      #d7d7d7 84.34%
    );
  }
}
.type.level_3 {
  background-color: #b5983f;
  &::after {
    background: linear-gradient(
      225.89deg,
      #dfca8f -2.61%,
      #d4bd78 12.38%,
      #b5983f 37.35%,
      #b5983f 57.32%,
      #d4bd78 84.34%
    );
  }
}
.type.level_4 {
  background-color: #858585;
  &::after {
    background: linear-gradient(
      225.89deg,
      #858585 -2.61%,
      #c1c1c1 14.02%,
      #6d6d6d 37.35%,
      #6d6d6d 57.32%,
      #999999 84.34%
    );
  }
}
.card.level_0 {
  background: linear-gradient(92.14deg, #fffcf9 9.77%, #ffdaad 50.56%, #ff9f4b 83.2%);
}
.card.level_1 {
  background: linear-gradient(92.14deg, #fffcf9 9.77%, #d5ccc7 50.56%, #996b4f 83.2%);
}
.card.level_2 {
  background: linear-gradient(
    92.14deg,
    #e6e6e6 1.61%,
    #ffffff 26.09%,
    #e6e6e6 50.56%,
    #b7b7b7 83.2%
  );
}
.card.level_3 {
  background: linear-gradient(
    92.14deg,
    #f1e2b3 1.61%,
    #ffffff 26.09%,
    #f1e2b3 50.56%,
    #b5983f 83.2%
  );
}
.card.level_4 {
  background: linear-gradient(
    92.14deg,
    #c1c1c1 1.61%,
    #ffffff 26.09%,
    #c1c1c1 50.56%,
    #6d6d6d 83.2%
  );
}
@keyframes loading {
  100% {
    transform: translateX(200%);
  }
}
.maskLoad {
  position: absolute;
  pointer-events: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
  border-radius: 12px;
}
.load {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.load::after {
  display: block;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateX(-200%);
  background: linear-gradient(
    -70deg,
    transparent,
    transparent,
    rgba(255, 255, 255, 0.5),
    transparent,
    transparent
  );
  animation: loading 3.5s infinite;
}
</style>
